export const Endpoints = {
  getRadioStartUp: "/prod/radiostartup",
  getAudio: "/prod/radio/message/:id/:audioId/mp3"
};
